export default "__VITE_ASSET__debf5ded__"